import BaseModel from './BaseModel';
import { getFilenameFromUrl } from '../helpers/functions';
import { getMomentDate } from '../utils/commonUtils';
import { orderBy, findIndex, get } from 'lodash';
import { getProvinceById, getProvinceByName } from './Province';

export default class Golf extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        let hasMatchingLanguage = false;
        
        if (data && data.translations && this.languageCode) {
            // Kiểm tra xem languageCode hiện tại có trong danh sách translations hay không
            hasMatchingLanguage = data.translations.some(t => t.languageCode === this.languageCode);
        }
        
        // Determine this.translate based on the passed data or this.clubI18Ns
        // Assuming this.languageCode has been set (e.g. in the constructor or a private setter)
        if (data && data.translate) {
            this.translate = data.translate;
        } else if (data && data.clubI18Ns && this.languageCode) {
            const currentTranslation = data.clubI18Ns.find(t => t.languageCode === this.languageCode);
            if (currentTranslation) {
                this.translate = currentTranslation;
            }
        }
        // If there is no data.translate or no translation found from clubI18Ns, 
        // this.translate will keep its current value (which can be undefined or from the previous set).

        this.id = data.id !== undefined ? data.id : this.id;
        
        // Nếu không có ngôn ngữ tương ứng trong data.translations thì gán rỗng cho các trường
        if (!hasMatchingLanguage) {
            this.name = '';
            this.website = '';
            this.shortDescription = '';
            this.description = '';
            this.address = '';
        } else {
            this.name = (this.translate && this.translate.hasOwnProperty('name') && this.translate.name !== undefined ) 
                ? this.translate.name 
                : (data.name);
            this.website = (this.translate && this.translate.hasOwnProperty('website')) ? this.translate.website : (data.website || '');
            this.shortDescription = (this.translate && this.translate.hasOwnProperty('shortDescription')) ? this.translate.shortDescription : (data.shortDescription || '');
            this.description = (this.translate && this.translate.hasOwnProperty('description')) ? this.translate.description : (data.description || '');
            this.address = (this.translate && this.translate.hasOwnProperty('address')) ? this.translate.address : (data.address || '');
        }
        
        this.code = data.code || '';
        this.orderNo = data.orderNo !== undefined ? data.orderNo : (this.orderNo || 0);
        this.active = data.active !== undefined ? data.active : (this.active || false);
        this.languages = data.languages || this.languages || [];
        this.images = data.images || this.images || [];
        this.clubI18Ns = data.clubI18Ns || this.clubI18Ns || [];
        this.hotline = data.hotline || '';
        this.email = data.email || '';
        this.googleMapUrl = data.googleMapUrl || '';
        this.media = data.images ? data.images.map(url => ({ url })) : [];
        this.locationId = data.locationId || '';
        this.supportPayLater = !!data.supportPayLater;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            code: this.code,
            orderNo: this.orderNo,
            active: this.active,
            languages: this.languages,
            images: this.images,
            clubI18Ns: this.clubI18Ns,
            hotline: this.hotline,
            email: this.email,
            website: this.website,
            shortDescription: this.shortDescription,
            description: this.description,
            address: this.address,
            googleMapUrl: this.googleMapUrl,
            media: this.media
        });
        
        if (hasTranslate && this.translate) {
            result.translate = () => {
                const translatedFields = {
                    id: this.translate.id,
                    golfId: this.id,
                    languageCode: this.translate.languageCode || this.languageCode,
                };
                if (this.translate.hasOwnProperty('name')) translatedFields.name = this.translate.name;
                if (this.translate.hasOwnProperty('shortDescription')) translatedFields.shortDescription = this.translate.shortDescription;
                if (this.translate.hasOwnProperty('description')) translatedFields.description = this.translate.description;
                if (this.translate.hasOwnProperty('address')) translatedFields.address = this.translate.address;
                if (this.translate.hasOwnProperty('website')) translatedFields.website = this.translate.website;

                return translatedFields;
            }
        }
        
        return result;
    }

    addMedia(url, name) {
        this.media.push({ url, order: this.media.length, name })
    }

    setMedia(data = {}) {
        this.media = data.media ? orderBy(data.media || [], ['order'], ['asc']) : (this.translate.media || []);
    }
    removeMedia(media) {
        let removeIndex;
        if (typeof media === 'string') {// by url
            removeIndex = findIndex(this.media, m => getFilenameFromUrl(m.url) === getFilenameFromUrl(media))
        } else if (typeof media === 'object' && media.order >= 0) {//by media object
            removeIndex = findIndex(this.media, m => m.order === media.order)
        } else {
            removeIndex = findIndex(this.media, (m, index) => this.media.indexOf(media) === index);
        }
        if (removeIndex >= 0) this.media = this.media.filter((m, index) => index !== removeIndex);
        this.media = this.media.map((m, index) => {
            if (index >= removeIndex) {
                m.order -= 1;
            }
            return m;
        })
    }

    setPosition(position = {}) {
        this.lat = position.lat;
        this.lng = position.lng;
    }
}
